<template>
    <div class="filter__col" v-if="!filter">
        <div class="filter__col-bg">
            <svg class="sprite-icon icon__filter" width="24" height="24">
                <use xlink:href="/img/sprite.svg#filter"></use>
            </svg>
            <p>
                <i18n-t keypath="dashboard.settings.dragFilterHere" />
            </p>
        </div>
    </div>
    <app-check-box-list
        v-else-if="type === 'checkboxList'"
        v-model="model"
        :options="options"
        :type="filter"
    />

    <range-slider
        v-else-if="type === 'rangeSlider'"
        v-model="model"
        :options="options"
        :type="filter"
    />

    <color-filter v-else-if="type === 'colorsList'" v-model="model" :options="options" />
</template>

<script lang="ts">
import { MainFilterItem } from "./main-filter-item";
export default MainFilterItem;
</script>

<style scoped></style>
